import { push } from 'connected-react-router'
import { show } from 'redux-modal'
import { GENERIC_MESSAGE_MODAL } from 'constant'
import DiscontinuedItemInQuoteSubComponent from 'components/Appointment/components/DiscontinuedItemInQuoteSubComponent'
import { getOrderId } from 'components/Appointment/selectors'
import { getAppointmentConfirmationUrl } from 'components/Appointment/helpers'
import {
  REMOVE_INACTIVE_TITLE,
  REMOVE_INACTIVE_MESSAGE
} from 'components/Appointment/constants'

export const navigateToApptConfirmation = () => async (dispatch, getState) => {
  const { myStore, shoppingData } = getState()
  const { quotedItemAndServices: { products } = {}} = shoppingData
  const orderId = getOrderId(shoppingData)

  if (products && products.length) {
    const hasInactiveItems = products.some(product => !product.isActive)

    if (hasInactiveItems) {
      const modalOptions = {
        title: REMOVE_INACTIVE_TITLE,
        text: REMOVE_INACTIVE_MESSAGE,
        SubComponents: DiscontinuedItemInQuoteSubComponent
      }

      dispatch(show(GENERIC_MESSAGE_MODAL, modalOptions))
      return
    }
  }

  try {
    dispatch(push(getAppointmentConfirmationUrl(
      false,
      myStore.storeId,
      orderId
    )))
  } catch (err) {
    console.error(err)
  }
}
